import { createAsyncThunk } from '@reduxjs/toolkit';
import { getIsHubless } from '../../../reducers/Portal';
import { DataFetchingError } from '../../../errors/DataFetchingError';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
import { RequestStatus } from '../../../interface';
import { selectDefaultHomeState } from '../selectors/default-home.selectors';
import { getUserHomeKeyRpc } from 'nav-client-types/NavConfigService-v2/operations';
import { rpcClient } from '../../../utils/API';
import { selectPortalId } from '../../../selectors/portal.selectors';
const fetchDefaultHomeKey = async portalId => {
  const response = await rpcClient.call(getUserHomeKeyRpc, {
    queryParameters: {
      portalId
    } // The client-type is missing the portalId query parameter
  });
  return response.homeKey;
};
export const getDefaultHomeThunk = createAsyncThunk('getDefaultHome', async (_, {
  rejectWithValue,
  getState
}) => {
  const state = getState();
  const isHubless = getIsHubless(state);
  const portalId = selectPortalId(state);
  if (isHubless || !portalId) {
    return rejectWithValue('Portal ID is required');
  }
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  try {
    return await fetchDefaultHomeKey(portalId);
  } catch (error) {
    const requestError = error;
    logger.error(new DataFetchingError('Failed to fetch default home', {
      statusCode: requestError.status,
      cause: requestError
    }));
    return rejectWithValue('Failed to fetch default home');
  }
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();
    const {
      status
    } = selectDefaultHomeState(state);
    return status === RequestStatus.IDLE;
  }
});